module.exports = __webpack_public_path__ + "static/media/servicetruck-pin.6ebf3046.svg";